var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.333 0h277.333C459.468 0 512 52.532 512 117.333v277.333C512 459.468 459.468 512 394.667 512H117.333C52.532 512 0 459.468 0 394.667V117.333C0 52.532 52.532 0 117.333 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.448 247.019l-149.333-96c-4.951-3.193-11.552-1.768-14.745 3.183a10.667 10.667 0 00-1.703 5.799v192c-.01 5.891 4.758 10.674 10.649 10.684 2.057.003 4.07-.588 5.799-1.703l149.333-96c4.96-3.178 6.405-9.776 3.227-14.736a10.658 10.658 0 00-3.227-3.227z",
    fill: "#928483"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.667 362.667c-5.891 0-10.667-4.776-10.667-10.667V160c0-5.891 4.776-10.667 10.667-10.667s10.667 4.776 10.667 10.667v192c-.001 5.891-4.776 10.667-10.667 10.667z",
    fill: "#928483"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.ced632c0.svg";
export { ForwardRef as ReactComponent };